import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const names = ['Valentina', 'Camila', 'Martina', 'Sofía', 'Lucía', 'Catalina', 'Julieta', 'Florencia', 'Micaela', 'Agustina', 'Delfina', 'Victoria', 'Milagros', 'Rocío', 'Antonella', 'Guillermina', 'Paula', 'Josefina', 'Emilia', 'Renata'];
const neighborhoods = ['Echesortu', 'Luis Agote', 'Arroyito', 'Centro', 'Ludueña', 'Belgrano', 'Fisherton', 'Roldán', 'Alberdi', 'Bella Vista'];
const services = [{
  name: 'Micropigmentación de Cejas',
  type: 'cejas'
}, {
  name: 'Micropigmentación de Labios',
  type: 'labios'
}, {
  name: 'Lash Lifting',
  type: 'pestanas'
}, {
  name: 'Extensión de Pestañas',
  type: 'pestanas'
}, {
  name: 'Henna de Cejas',
  type: 'cejas'
}, {
  name: 'Perfilado de Cejas',
  type: 'cejas'
}];
const ServiceIcon = ({
  type
}: {
  type: string;
}) => {
  if (type === 'labios') {
    return <span className="text-2xl" role="img" aria-label="Labios" data-id="element-64">
        💋
      </span>;
  }
  if (type === 'pestanas') {
    return <span className="text-2xl" role="img" aria-label="Pestañas" data-id="element-65">
        👁️
      </span>;
  }
  // Default to cejas
  return <span className="text-2xl" role="img" aria-label="Cejas" data-id="element-66">
      ✨
    </span>;
};
interface ToastData {
  id: number;
  name: string;
  neighborhood: string;
  service: (typeof services)[0];
  timeAgo: string;
}
export function BookingToast() {
  const {
    t
  } = useLanguage();
  const [toast, setToast] = useState<ToastData | null>(null);
  const [recentNames, setRecentNames] = useState<string[]>([]);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showNextToast = () => {
      // Pick random data
      let availableNames = names.filter(n => !recentNames.includes(n));
      if (availableNames.length === 0) availableNames = names; // fallback if all used
      const randomName = availableNames[Math.floor(Math.random() * availableNames.length)];
      const randomNeighborhood = neighborhoods[Math.floor(Math.random() * neighborhoods.length)];
      const randomService = services[Math.floor(Math.random() * services.length)];
      const randomMinutes = Math.floor(Math.random() * 59) + 1;
      // Update recent names history (keep last 10)
      setRecentNames(prev => {
        const newHistory = [...prev, randomName];
        if (newHistory.length > 10) newHistory.shift();
        return newHistory;
      });
      setToast({
        id: Date.now(),
        name: randomName,
        neighborhood: randomNeighborhood,
        service: randomService,
        timeAgo: `${t('toast_hace')} ${randomMinutes} ${t('toast_min')}`
      });
      // Hide after 3 seconds
      setTimeout(() => {
        setToast(null);
        // Schedule next toast exactly 10 seconds later
        timeoutId = setTimeout(showNextToast, 10000);
      }, 3000);
    };
    // Initial delay of exactly 10 seconds
    timeoutId = setTimeout(showNextToast, 10000);
    return () => clearTimeout(timeoutId);
  }, []); // Empty dependency array prevents multiple overlapping timeouts
  return <div className="fixed bottom-6 left-6 z-50 pointer-events-none" data-id="element-67">
      <AnimatePresence data-id="element-68">
        {toast && <motion.div key={toast.id} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white/90 backdrop-blur-md border border-[#D4AF37]/30 shadow-[0_8px_30px_rgba(0,0,0,0.12)] rounded-2xl p-4 flex items-center gap-4 max-w-sm pointer-events-auto" data-id="element-69">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#FDF6F0] border border-[#D4AF37]/20 flex items-center justify-center" data-id="element-70">
              <ServiceIcon type={toast.service.type} data-id="element-71" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-72">
              <p className="text-sm text-[#2C1810] leading-tight" data-id="element-73">
                <span className="font-medium" data-id="element-74">{toast.name}</span>{' '}
                {t('toast_de')} {toast.neighborhood}
              </p>
              <p className="text-xs text-[#7A5C4F] mt-1 pr-4" data-id="element-75">
                {t('toast_agendo')}{' '}
                <span className="font-medium text-[#C9956A]" data-id="element-76">
                  {t('srv' + (services.indexOf(toast.service) + 1) + '_t')}
                </span>
              </p>
              <p className="text-[10px] text-gray-400 mt-1.5 font-medium" data-id="element-77">
                {toast.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}